import request from '@/utils/request'

export function getApproveEmpList(data) {
  return request.post('/approve-emp-config/list', data)
}

export function addApproveEmp(data) {
  return request.post('/approve-emp-config/add', data)
}

export function modifyApproveEmp(data) {
  return request.post('/approve-emp-config/modify', data)
}

export function deleteApproveEmp(data) {
  return request.post('/approve-emp-config/delete', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/approve-manage.js